import _Vue, { PluginFunction, PluginObject } from 'vue';

import DataTable from './DataTable.vue';

export function DataTablePlugin(Vue: typeof _Vue, options?: {}) {
  Vue.component('data-table', DataTable);
}
